            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate >  
        <b-row style="width:100%">
          <b-col sm="12">
            <b-row  class="row-inputs">
              <sw-inputs
                inputTabla="info_ingresos"
                inputCampo="id_list_forma"
                :cols="12"  :lg="4">
              </sw-inputs>
              <sw-inputs 
                v-if="dataForm[namePath].info_ingresos.id_list_forma===1"
                inputTabla="info_ingresos"
                inputCampo="id_list_cuentas"
                :cols="12"  :lg="4">
              </sw-inputs>
              <sw-inputs
                v-if="dataForm[namePath].info_ingresos.id_list_forma===1"
                inputTabla="info_ingresos"
                inputCampo="consignacion"
                :cols="12" :lg="4">
              </sw-inputs>       
            </b-row>
          </b-col>
        </b-row>  
      </b-form>    
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn="Registro"
              :invalid="invalid || dataForm[namePath].info_ingresos.id_list_forma===2 || dataForm[namePath].info_ingresos.id_list_forma===5"
              @save="save"
              >
            </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    SwSaveform
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    }
  },
  computed: {    
    ...mapState({
    })
  },
  async created()
  {
    
    const await1 = this.updateDataForm({ data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]]})
    await await1
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed(){
    await this.resetDataForm()
  },
  methods: {
    async save(emit)
    {
      if(this.namePath==='afiliacion_descargar')
      {
        await this.updateDataForm({state:'info_ingresos/fecha', data: this.fecha().fecha.minHoy})
      }      
      if(this.dataForm[this.namePath].info_ingresos.id_list_forma!==2 && this.dataForm[this.namePath].info_ingresos.id_list_forma!==5)
      {
          this.$emit('save', { save: emit.save, ftn: 'descargarAflFtn'})
      }      
    },
  }
}
</script>
<style>
</style>